<!--
     <TextInput
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Public methods:
       validate → Makes validation and returns if the value is valid

     Accepted props:
     - size
     - value
     - label
     - placeholder
-->

<template>
  <v-text-field
    v-model="props.value"
    :size="props.size"
    :label="props.label"
    :placeholder="props.placeholder"
    :rules="rules"
    :readonly="!!props.readonly"
    @error="error_state"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    outlined
    dense
    background-color="#f2f2f2"
  >
  </v-text-field>
</template>


<script>
 export default {
   name: 'TextInput',

   props: ['props', 'required_rule'],

   data: (() => ({
     valid: true,
   })),

   computed: {
     value() {
       return this.props.value;
     },
     rules() {
       // TODO: Multilang: Change hardcoded string
       return [
         value => !!value || !this.props.required || 'Campo requerido'         
       ];
     }
   },

   methods: {
     validate() {
       return this.valid;
     },

     error_state(ok) {
       this.valid = ok;
     },
   },
 }
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>